import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { onlyText } from 'react-children-utilities';
import { Text } from '../../..';
import { useThemeValues } from '../../../../hooks';

export const ListRowSubtitle = ({
  children,
  as = Text,
  isCompactMode,
  ...rest
}: {
  children: ReactNode;
  as?: React.ElementType;
  isCompactMode?: boolean;
}) => {
  const { fontSize, spacing } = useThemeValues();
  const Component = as;

  return (
    <Component
      css={css`
        font-size: ${isCompactMode ? fontSize(12) : fontSize(14)};
        margin: ${spacing(0.5, 0)};
        display: -webkit-box;
        -webkit-line-clamp: ${isCompactMode ? 1 : 2};
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      `}
      title={onlyText(children as React.ReactNode)}
      className='content-column-subtitle'
      {...rest}
    >
      {children}
    </Component>
  );
};
